import React from "react";
const DraggableHOC = (Component) => {
  const Draggable = (props) => {
    const { disabled, ...restProps } = props;
    return /* @__PURE__ */ React.createElement("div", { ...disabled ? void 0 : { "data-drag-handle": true, draggable: true } }, /* @__PURE__ */ React.createElement(Component, { ...restProps }));
  };
  Draggable.displayName = "Draggable";
  return Draggable;
};
export {
  DraggableHOC
};
//# sourceMappingURL=draggable-hoc.js.map
